import { DLGWOfferingType } from '@capital-markets-gateway/api-client-datalab-gateway';

import { Country, OfferingType } from '../../graphql/__generated__';
import { sellSideParticipationSupportedOfferingTypes } from '../../types/domain/participation-sets/constants';
import { useCanManageDemandAnalyticsUpload } from './useCanManageDemandAnalyticsUpload';

export type CombinedOfferingType = OfferingType | DLGWOfferingType;
export const useCanUploadParticipationDataOnOffering = (): ((
  offeringType?: OfferingType | DLGWOfferingType,
  exchangeCountry?: Country | null
) => boolean) => {
  const canManageSellSideParticipationData = useCanManageDemandAnalyticsUpload();
  return (
    offeringType?: OfferingType | DLGWOfferingType,
    exchangeCountry: Country | null = Country.Us
  ) => {
    // optional check to see if this is a US offering
    const isUS = exchangeCountry === Country.Us;
    return offeringType &&
      sellSideParticipationSupportedOfferingTypes.includes(offeringType as OfferingType) &&
      canManageSellSideParticipationData &&
      isUS
      ? true
      : false;
  };
};
